module.exports = __webpack_public_path__ + "img/bnb.2626df36.svg";